import {
  ADD_TRANSPORT_DETAILS,
  CREATE_ORDER,
  LIST_OF_ORDER,
  ORDER_PAYMENT,
  ORDER_REFUND,
  UPDATE_ORDER_HISTORY,
  VIEW_ORDER,
  VIEW_ORDER_HISTORY,
  VIEW_TRANSPORT_DETAILS,
} from "./ApiRoutes";
import { authData } from "./services";

export const createOrder = async (data: object) => {
  const response = await authData.post(CREATE_ORDER, data);
  return response?.data;
};
export const viewOrderApi = async (id: number) => {
  const response = await authData.get(`${VIEW_ORDER}${id}`);
  return response?.data;
};
export const listOfOrder = async (data: object) => {
  const response = await authData.post(LIST_OF_ORDER, data);
  return response?.data;
};
export const orderPaymentApi = async (id: number, data: object) => {
  const response = await authData.post(`${ORDER_PAYMENT}${id}`, data);
  return response?.data;
};
export const viewOrderHistory = async (id: number, data: object) => {
  const response = await authData.post(`${VIEW_ORDER_HISTORY}${id}`, data);
  return response?.data;
};
export const updateOrderHistory = async (id: number, data: object) => {
  const response = await authData.post(`${UPDATE_ORDER_HISTORY}${id}`, data);
  return response?.data;
};
export const orderRefund = async (data: object) => {
  const response = await authData.post(ORDER_REFUND, data);
  return response?.data;
};
export const addTransportDetails = async (orderId: number, data: object) => {
  const response = await authData.post(
    `${ADD_TRANSPORT_DETAILS}${orderId}`,
    data
  );
  return response?.data;
};
export const viewTransportDetails = async (orderId: number) => {
  const response = await authData.get(`${VIEW_TRANSPORT_DETAILS}${orderId}`);
  return response?.data;
};
